const SUPPORTED_LOCALES = ['fr'];

/**
 * @returns {Promise} resolves once react-intl locales and intl are loaded and setup
 */
const setupIntl = () => {
    if (!global.Intl) {
        return Promise.all(import('intl'), import('intl/locale-data/jsonp/fr'));
    }

    return Promise.resolve(true);
};

export { setupIntl, SUPPORTED_LOCALES };
